import React from 'react';
import SeverityFace from '../SeverityFace';
import { DAY_PERIODS } from '../../../../constants/journey';
import {
	eachDay,
	formatWeekdayShort,
	formatDayOfMonth,
	formatMediumDate,
	todayISO,
} from '../../../../utils/journeyDates';
import styles from './WeekGrid.module.css';

// A 4 x 7 matrix, not a calendar: time-of-day row headers against date columns.
// Buckets with no submission come back omitted, so a missing key is an empty cell.
const WeekGrid = ({ period, cells = [] }) => {
	const days = eachDay(period.start, period.end);
	const today = todayISO();

	const ratings = cells.reduce((map, cell) => {
		map[`${cell.date}|${cell.period}`] = cell.rating;
		return map;
	}, {});

	const hasAnything = cells.length > 0;

	return (
		<div className={styles.wrapper}>
			<table className={styles.table}>
				<caption className={styles.caption}>
					Reported severity by time of day, {period.label}
				</caption>
				<thead>
					<tr>
						<th scope='col' className={styles.corner}>
							<span className={styles.srOnly}>Time of day</span>
						</th>
						{days.map((day) => (
							<th
								key={day}
								scope='col'
								className={`${styles.dayHeader} ${
									day === today ? styles.dayHeaderToday : ''
								}`}
							>
								<span className={styles.weekday}>{formatWeekdayShort(day)}</span>
								<span className={styles.dayNumber}>{formatDayOfMonth(day)}</span>
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{DAY_PERIODS.map(({ key, label, hint }) => (
						<tr key={key}>
							<th scope='row' className={styles.periodHeader}>
								<span className={styles.periodLabel}>{label}</span>
								<span className={styles.periodHint}>{hint}</span>
							</th>
							{days.map((day) => {
								const rating = ratings[`${day}|${key}`];
								return (
									<td key={day} className={styles.cell}>
										{rating ? (
											<SeverityFace rating={rating} size={30} />
										) : (
											<span
												className={styles.empty}
												aria-label={`No entry, ${label.toLowerCase()} of ${formatMediumDate(
													day
												)}`}
											/>
										)}
									</td>
								);
							})}
						</tr>
					))}
				</tbody>
			</table>

			{!hasAnything && (
				<p className={styles.emptyNote}>
					<span>Nothing tracked this week yet.</span>
					<span>
						Ratings you record show up here by the time of day you made them.
					</span>
				</p>
			)}
		</div>
	);
};

export default WeekGrid;
